import styled from "styled-components";

export const Container = styled.section`
    width: 100%;
    background-color: white;
`
export const Wrap = styled.div`
    max-width: 1140px;
    margin: 0 auto;
    padding: 20px 0;
`
export const Text = styled.p`
    width: 66.66666667%;
    margin:  0 auto;
    font-size: 16px;
    color: #777777;
    font-weight: normal;
    line-height: 1.66em;
    text-align: center;
    position: relative;
    padding: 40px 0;
    &::after{
        position: absolute;
        content: "";
        width: 30px;
        height: 3px;
        background-color: #ff7f00;
        bottom: 17px;
        right: 50%;
        transform: translateX(50%);
    }
    &::before{
        position: absolute;
        content: "";
        width: 30px;
        height: 3px;
        background-color: #ff7f00;
        top: 20px;
        right: 50%;
        transform: translateX(50%);
    }
`